import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import ProductCategories from './components/ProductCategories'; 
import Contact from './components/Contact';
import Footer from './components/Footer';
import Processing from './components/processing';

// --- CHANGE IS HERE ---
import './App.css'; 
import './components/Home.css'; // Import Home.css here instead of in Home.js
// ----------------------

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products/:categoryName" element={<ProductCategories />} />
          <Route path="/products" element={<ProductCategories />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/processing" element={<Processing />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;